import type { FC } from "react";
import { Flag, type FlagProps } from "./Flag";

export type FlagAction = {
	label: string;
	onClick: () => void;
	actionId?: string;
};

export type FlagWithActionsProps = Omit<FlagProps, "children"> & {
	actions: FlagAction[];
};

/** A `Flag` that renders a required set of action buttons in its body. */
export const FlagWithActions: FC<FlagWithActionsProps> = ({ actions, onClose, ...props }) => (
	<Flag {...props} onClose={onClose}>
		{actions.length > 0 && (
			<div className="mt-1 flex flex-wrap gap-x-3">
				{actions.map((action) => (
					// TODO(DEV-3017): replace with the EphemeralButton primitive once it exists.
					<button
						key={action.actionId ?? action.label}
						type="button"
						data-testid="flag-action-button"
						className="cursor-pointer text-sm font-medium text-link hover:text-link-hover"
						onClick={() => {
							action.onClick();
							onClose();
						}}
					>
						{action.label}
					</button>
				))}
			</div>
		)}
	</Flag>
);
